import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSidebars, setActiveSidebar } from '../actions/SidebarActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane, Badge } from 'evergreen-ui';

class ListSidebar extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getSidebars(opts));
    }

    handleSetActive = (id) => {
        if (window.confirm('Esti sigur ca vrei sa activezi acest sidebar?')) {
            this.props.dispatch(setActiveSidebar(id));
        }
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/sidebar/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Sidebar Nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    { id: 'id', label: 'Id' },
                    { id: 'name', label: 'Nume' },
                    { 
                        id: 'active', 
                        label: 'Status',
                        decorator: (value) => value ? 
                            <Badge color="green">ACTIV</Badge> : 
                            <Badge color="neutral">Inactiv</Badge>
                    },
                    { id: 'createdAt', label: 'Creat', decorator: 'date' },
                    { id: 'updatedAt', label: 'Modificat', decorator: 'date' }
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/sidebar/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/sidebar/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.sidebar;
}

export default connect(mapStateToProps)(ListSidebar);
